(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[281],{

/***/ 14829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgChevronLeft = function SvgChevronLeft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgChevronLeft);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43MDcxIDUuMjkyODlDMTYuMDk3NiA1LjY4MzQyIDE2LjA5NzYgNi4zMTY1OCAxNS43MDcxIDYuNzA3MTFMMTAuNDE0MiAxMkwxNS43MDcxIDE3LjI5MjlDMTYuMDk3NiAxNy42ODM0IDE2LjA5NzYgMTguMzE2NiAxNS43MDcxIDE4LjcwNzFDMTUuMzE2NiAxOS4wOTc2IDE0LjY4MzQgMTkuMDk3NiAxNC4yOTI5IDE4LjcwNzFMOC4yOTI4OSAxMi43MDcxQzcuOTAyMzcgMTIuMzE2NiA3LjkwMjM3IDExLjY4MzQgOC4yOTI4OSAxMS4yOTI5TDE0LjI5MjkgNS4yOTI4OUMxNC42ODM0IDQuOTAyMzcgMTUuMzE2NiA0LjkwMjM3IDE1LjcwNzEgNS4yOTI4OVoiIC8+Cjwvc3ZnPgog");

/***/ }),

/***/ 7556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCircleXFilled = function SvgCircleXFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47718 2 2.00002 6.47715 2.00002 12C2.00002 17.5228 6.47718 22 12 22C17.5229 22 22 17.5228 22 12C22 6.47715 17.5229 2 12 2ZM15.2796 8.72018C15.7066 9.14711 15.7066 9.83931 15.2796 10.2663L13.5459 12L15.2796 13.7337C15.7066 14.1606 15.7066 14.8528 15.2796 15.2798C14.8527 15.7067 14.1605 15.7067 13.7336 15.2798L11.9998 13.546L10.2663 15.2796C9.83934 15.7065 9.14714 15.7065 8.7202 15.2796C8.29327 14.8527 8.29326 14.1605 8.7202 13.7335L10.4538 12L8.7202 10.2664C8.29326 9.83948 8.29326 9.14728 8.7202 8.72034C9.14714 8.29341 9.83934 8.29341 10.2663 8.72034L11.9998 10.4539L13.7336 8.72018C14.1605 8.29324 14.8527 8.29324 15.2796 8.72018Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgCircleXFilled);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyQzYuNDc3MTggMiAyLjAwMDAyIDYuNDc3MTUgMi4wMDAwMiAxMkMyLjAwMDAyIDE3LjUyMjggNi40NzcxOCAyMiAxMiAyMkMxNy41MjI5IDIyIDIyIDE3LjUyMjggMjIgMTJDMjIgNi40NzcxNSAxNy41MjI5IDIgMTIgMlpNMTUuMjc5NiA4LjcyMDE4QzE1LjcwNjYgOS4xNDcxMSAxNS43MDY2IDkuODM5MzEgMTUuMjc5NiAxMC4yNjYzTDEzLjU0NTkgMTJMMTUuMjc5NiAxMy43MzM3QzE1LjcwNjYgMTQuMTYwNiAxNS43MDY2IDE0Ljg1MjggMTUuMjc5NiAxNS4yNzk4QzE0Ljg1MjcgMTUuNzA2NyAxNC4xNjA1IDE1LjcwNjcgMTMuNzMzNiAxNS4yNzk4TDExLjk5OTggMTMuNTQ2TDEwLjI2NjMgMTUuMjc5NkM5LjgzOTM0IDE1LjcwNjUgOS4xNDcxNCAxNS43MDY1IDguNzIwMiAxNS4yNzk2QzguMjkzMjcgMTQuODUyNyA4LjI5MzI2IDE0LjE2MDUgOC43MjAyIDEzLjczMzVMMTAuNDUzOCAxMkw4LjcyMDIgMTAuMjY2NEM4LjI5MzI2IDkuODM5NDggOC4yOTMyNiA5LjE0NzI4IDguNzIwMiA4LjcyMDM0QzkuMTQ3MTQgOC4yOTM0MSA5LjgzOTM0IDguMjkzNDEgMTAuMjY2MyA4LjcyMDM0TDExLjk5OTggMTAuNDUzOUwxMy43MzM2IDguNzIwMThDMTQuMTYwNSA4LjI5MzI0IDE0Ljg1MjcgOC4yOTMyNCAxNS4yNzk2IDguNzIwMThaIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 78975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C11.8487 18 13.551 17.3729 14.9056 16.3199L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L16.3199 14.9056C17.3729 13.551 18 11.8487 18 10C18 5.58172 14.4183 2 10 2Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgSearch);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDEwQzQgNi42ODYyOSA2LjY4NjI5IDQgMTAgNEMxMy4zMTM3IDQgMTYgNi42ODYyOSAxNiAxMEMxNiAxMy4zMTM3IDEzLjMxMzcgMTYgMTAgMTZDNi42ODYyOSAxNiA0IDEzLjMxMzcgNCAxMFpNMTAgMkM1LjU4MTcyIDIgMiA1LjU4MTcyIDIgMTBDMiAxNC40MTgzIDUuNTgxNzIgMTggMTAgMThDMTEuODQ4NyAxOCAxMy41NTEgMTcuMzcyOSAxNC45MDU2IDE2LjMxOTlMMjAuMjkyOSAyMS43MDcxQzIwLjY4MzQgMjIuMDk3NiAyMS4zMTY2IDIyLjA5NzYgMjEuNzA3MSAyMS43MDcxQzIyLjA5NzYgMjEuMzE2NiAyMi4wOTc2IDIwLjY4MzQgMjEuNzA3MSAyMC4yOTI5TDE2LjMxOTkgMTQuOTA1NkMxNy4zNzI5IDEzLjU1MSAxOCAxMS44NDg3IDE4IDEwQzE4IDUuNTgxNzIgMTQuNDE4MyAyIDEwIDJaIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 78127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[category]",
      function () {
        return __webpack_require__(85119);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GuidesCategory": function() { return /* binding */ GuidesCategory; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(90010);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/button/button.tsx
var button_button = __webpack_require__(79544);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/search-bar/index.tsx
var search_bar = __webpack_require__(82942);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/spinner/index.tsx
var spinner = __webpack_require__(9114);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-update-header.tsx
var use_update_header = __webpack_require__(41898);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/utils/constants.ts + 14 modules
var constants = __webpack_require__(68579);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-clean-header.tsx
var use_clean_header = __webpack_require__(90573);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/seo/index.tsx
var seo = __webpack_require__(25352);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/category-blog-frame.svg
var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCategoryBlogFrame = function SvgCategoryBlogFrame(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 132,
    height: 60,
    viewBox: "0 0 132 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_5376_17615)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M110.197 96.7717H100.493L121.963 0H131.667L110.197 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M88.5686 96.7717H78.8643L100.339 0H110.044L88.5686 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M66.9475 96.7717H57.2432L78.7183 0H88.4227L66.9475 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M45.3225 96.7717H35.6182L57.0884 0H66.7928L45.3225 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M23.7014 96.7717H13.9971L35.4673 0H45.1717L23.7014 96.7717Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M2.07664 96.7717H-7.62769L13.8475 0H23.5518L2.07664 96.7717Z",
    fill: "#E98EAA"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_5376_17615"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 132,
    height: 60,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCategoryBlogFrame);

/* harmony default export */ var category_blog_frame = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMyIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMTMyIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTM3Nl8xNzYxNSkiPgo8cGF0aCBkPSJNMTEwLjE5NyA5Ni43NzE3SDEwMC40OTNMMTIxLjk2MyAwSDEzMS42NjdMMTEwLjE5NyA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNODguNTY4NiA5Ni43NzE3SDc4Ljg2NDNMMTAwLjMzOSAwSDExMC4wNDRMODguNTY4NiA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNNjYuOTQ3NSA5Ni43NzE3SDU3LjI0MzJMNzguNzE4MyAwSDg4LjQyMjdMNjYuOTQ3NSA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNNDUuMzIyNSA5Ni43NzE3SDM1LjYxODJMNTcuMDg4NCAwSDY2Ljc5MjhMNDUuMzIyNSA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNMjMuNzAxNCA5Ni43NzE3SDEzLjk5NzFMMzUuNDY3MyAwSDQ1LjE3MTdMMjMuNzAxNCA5Ni43NzE3WiIgZmlsbD0iI0U5OEVBQSIvPgo8cGF0aCBkPSJNMi4wNzY2NCA5Ni43NzE3SC03LjYyNzY5TDEzLjg0NzUgMEgyMy41NTE4TDIuMDc2NjQgOTYuNzcxN1oiIGZpbGw9IiNFOThFQUEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF81Mzc2XzE3NjE1Ij4KPHJlY3Qgd2lkdGg9IjEzMiIgaGVpZ2h0PSI2MCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/blog/article-list/index.tsx + 2 modules
var article_list = __webpack_require__(34792);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/website-layout/index.tsx + 9 modules
var website_layout = __webpack_require__(46087);
// EXTERNAL MODULE: ../../libs/utils/src/lib/helpers.ts
var helpers = __webpack_require__(44386);
// EXTERNAL MODULE: ../../libs/utils/src/lib/website/website-strapi.ts
var website_strapi = __webpack_require__(82185);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/graphql/website/get-all-blog-posts.generated.ts
var get_all_blog_posts_generated = __webpack_require__(86367);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/types.generated.ts
var types_generated = __webpack_require__(9432);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/assets/icons/chevron-left.svg
var chevron_left = __webpack_require__(14829);
// EXTERNAL MODULE: ./pages/blog/category.module.scss
var category_module = __webpack_require__(8801);
var category_module_default = /*#__PURE__*/__webpack_require__.n(category_module);
;// CONCATENATED MODULE: ./pages/blog/[category].tsx










const FIRST_PAGE = 1;
const PAGES_SIZE = 12;
const LATEST_NEWS = "latest-news";
const SEO = {
    title: "Blog // Olby",
    description: "Insights on international career, remote work, productivity, work-life balance, engineering, team management and leadership."
};
var __N_SSP = true;
const GuidesCategory = ()=>{
    const { register , reset , handleSubmit , formState: { dirtyFields  }  } = (0,index_esm/* useForm */.cI)({
        mode: "onSubmit",
        defaultValues: {
            searchPostCategory: ""
        }
    });
    const router = (0,next_router.useRouter)();
    const contentRef = (0,react.useRef)(null);
    const category = (0,react.useMemo)(()=>(0,helpers/* formatWebsitePostCategory */.gP)(router.query.category), [
        router.query.category
    ]);
    const isLatestNews = router.query.category === LATEST_NEWS;
    const { data , fetchNextPage , isFetchingNextPage  } = (0,get_all_blog_posts_generated/* useInfiniteGetAllBlogPostsQuery */.Ez)({
        input: {
            ...isLatestNews ? {
                sort: [
                    {
                        createdAt: types_generated/* SortingDirection.Desc */.X_.Desc
                    }
                ]
            } : {
                filters: {
                    category: {
                        name: {
                            containsi: category
                        }
                    }
                }
            },
            pagination: {
                page: FIRST_PAGE,
                pageSize: PAGES_SIZE
            }
        }
    }, {
        enabled: false,
        keepPreviousData: true,
        getNextPageParam: (lastPage)=>{
            var ref, ref1, ref2, ref3, ref4, ref5;
            const lastPageNumber = Number((ref = lastPage.getAllBlogPosts) === null || ref === void 0 ? void 0 : (ref1 = ref.pagination) === null || ref1 === void 0 ? void 0 : ref1.page);
            if (lastPageNumber !== ((ref2 = lastPage.getAllBlogPosts) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pagination) === null || ref3 === void 0 ? void 0 : ref3.pageCount) && !!((ref4 = lastPage.getAllBlogPosts) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.pagination) === null || ref5 === void 0 ? void 0 : ref5.pageCount)) {
                return {
                    input: {
                        ...isLatestNews ? {
                            sort: [
                                {
                                    createdAt: types_generated/* SortingDirection.Desc */.X_.Desc
                                }
                            ]
                        } : {
                            filters: {
                                category: {
                                    name: {
                                        containsi: category
                                    }
                                }
                            }
                        },
                        pagination: {
                            page: lastPageNumber + 1,
                            pageSize: PAGES_SIZE
                        }
                    }
                };
            }
            return undefined;
        }
    });
    const articleList = (0,react.useMemo)(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.pages)) {
            return [];
        }
        const list = data.pages.flatMap((page)=>page.getAllBlogPosts.data);
        return (0,website_strapi/* websiteFormatArticleList */.o)(list);
    }, [
        data
    ]);
    const crumbs = (0,react.useMemo)(()=>[
            {
                id: "blog",
                label: "Blog",
                href: "/blog"
            },
            {
                id: "".concat(category),
                label: "".concat(category),
                href: "/"
            }
        ], [
        category
    ]);
    const onSearchClear = (0,react.useCallback)(()=>{
        reset({
            searchPostCategory: ""
        });
    }, [
        reset
    ]);
    const onSubmit = handleSubmit((data)=>{
        if (dirtyFields.searchPostCategory) {
            router.push({
                pathname: "/blog/search-results",
                query: {
                    category: router.query.category,
                    searchPostsCategory: data.searchPostCategory
                }
            });
        }
    });
    const onLoadMore = (0,react.useCallback)(()=>{
        fetchNextPage();
    }, [
        fetchNextPage
    ]);
    (0,use_update_header/* useUpdateHeader */.G)(contentRef, constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND);
    (0,use_clean_header/* useCleanHeader */._)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (category_module_default())["main-search-content"],
        ref: contentRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* WebsiteSeo */.P, {
                seo: SEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: (category_module_default())["guides-category-header"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs/* Breadcrumbs */.O, {
                        crumbs: crumbs,
                        className: (category_module_default()).breadcrumbs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
                        startAdornment: chevron_left/* ReactComponent */.r,
                        className: (category_module_default())["back-mobile-button"],
                        href: "/blog",
                        prefetch: false,
                        children: "Blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (category_module_default())["category-title-container"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                                className: (category_module_default()).frame
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (category_module_default())["page-category-title"],
                                children: category
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        className: (category_module_default())["search-wrapper"],
                        onSubmit: onSubmit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar/* SearchBar */.E, {
                            id: "search-post",
                            label: "Search ".concat(category, " guides"),
                            hiddenLabel: true,
                            variant: "search-with-submit",
                            placeholder: "Search for ".concat(category.toLowerCase(), " posts"),
                            onSearchClear: onSearchClear,
                            ...register("searchPostCategory")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (category_module_default())["articles-wrapper"],
                children: [
                    Boolean(articleList.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(article_list/* ArticleList */.w, {
                        posts: articleList,
                        onLoadMore: onLoadMore,
                        hideCategoryTag: !isLatestNews,
                        className: (category_module_default())["articles-list"]
                    }),
                    isFetchingNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (category_module_default())["spinner-container"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                            size: "large"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _category_ = (GuidesCategory);
GuidesCategory.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(website_layout/* WebsiteLayout */.CG, {
        shouldChangeBgColor: true,
        headerInitialTheme: constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND,
        children: page
    });
};


/***/ }),

/***/ 97885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ customFetcher; }
/* harmony export */ });
const customFetcher = (query, variables, options)=>{
    return async ()=>{
        const NEXT_PUBLIC_API_URL = "https://platform-api.olby.com/graphql";
        const res = await fetch(NEXT_PUBLIC_API_URL || "https://platform-api.olby.com/graphql", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Accept: "application/json",
                ...options
            },
            body: JSON.stringify({
                query,
                variables
            })
        });
        const json = await res.json();
        if (json.errors) {
            const errors = json.errors[0];
            throw errors;
        }
        return json.data;
    };
};


/***/ }),

/***/ 86367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ez": function() { return /* binding */ useInfiniteGetAllBlogPostsQuery; }
/* harmony export */ });
/* unused harmony exports GetAllBlogPostsDocument, useGetAllBlogPostsQuery */
/* harmony import */ var _blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71285);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60431);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var libs_data_access_src_lib_custom_fetcher___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97885);
/* eslint-disable */ // @ts-nocheck



const GetAllBlogPostsDocument = /*#__PURE__*/ "\n    query GetAllBlogPosts($input: BlogPostQueryArgs!) {\n  getAllBlogPosts(input: $input) {\n    data {\n      article\n      resume\n      slug\n      title\n      readingTime\n      ...GetBlogPostBySlugAuthorFragment\n      ...GetBlogPostBySlugImageFragment\n      ...GetBlogPostBySlugTagsFragment\n      ...GetBlogPostBySlugSeoFragment\n      ...GetBlogPostBySlugCategoryFragment\n      id\n    }\n    pagination {\n      page\n      pageCount\n      pageSize\n      total\n    }\n  }\n}\n    ".concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugAuthorFragmentFragmentDoc */ .s_, "\n").concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugImageFragmentFragmentDoc */ .FD, "\n").concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugTagsFragmentFragmentDoc */ .E6, "\n").concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugSeoFragmentFragmentDoc */ .mW, "\n").concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugCategoryFragmentFragmentDoc */ .Wj);
const useGetAllBlogPostsQuery = (variables, options)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
        "GetAllBlogPosts",
        variables
    ], (0,libs_data_access_src_lib_custom_fetcher___WEBPACK_IMPORTED_MODULE_2__/* .customFetcher */ .k)(GetAllBlogPostsDocument, variables), options);
useGetAllBlogPostsQuery.getKey = (variables)=>[
        "GetAllBlogPosts",
        variables
    ];
const useInfiniteGetAllBlogPostsQuery = (variables, options)=>{
    var _pageParam;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery)([
        "GetAllBlogPosts.infinite",
        variables
    ], (metaData)=>(0,libs_data_access_src_lib_custom_fetcher___WEBPACK_IMPORTED_MODULE_2__/* .customFetcher */ .k)(GetAllBlogPostsDocument, {
            ...variables,
            ...(_pageParam = metaData.pageParam) !== null && _pageParam !== void 0 ? _pageParam : {}
        })(), options);
};
useInfiniteGetAllBlogPostsQuery.getKey = (variables)=>[
        "GetAllBlogPosts.infinite",
        variables
    ];
useGetAllBlogPostsQuery.fetcher = (variables, options)=>(0,libs_data_access_src_lib_custom_fetcher___WEBPACK_IMPORTED_MODULE_2__/* .customFetcher */ .k)(GetAllBlogPostsDocument, variables, options);


/***/ }),

/***/ 90010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13090);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Breadcrumbs = (param)=>{
    let { crumbs , className , variant ="default"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        "aria-label": "breadcrumb",
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().breadcrumb), (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[variant], className),
        children: crumbs.map((crumb, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().crumb),
                children: index !== crumbs.length - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: crumb.href,
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label),
                            children: crumb.label
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().slash),
                            children: "/"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-disabled": true,
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label), (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().disabled)),
                    children: crumbs[crumbs.length - 1].label
                })
            }, crumb.id))
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Breadcrumbs)));


/***/ }),

/***/ 82942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SearchBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _platform_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43287);
/* harmony import */ var _platform_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67071);
/* harmony import */ var _assets_icons_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78975);
/* harmony import */ var _assets_icons_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7556);
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48031);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86565);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);







const SearchBar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { label , id , searchButtonType ="submit" , size ="medium" , variant ="live-search" , onSearchClear , onSearchSubmit , className ="" , inputClassName ="" , disabled =false , hiddenLabel =false , trackingIdentifier , shouldTrackTerms =false , ...rest } = param;
    const innerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, ()=>innerRef.current);
    (0,_platform_utils__WEBPACK_IMPORTED_MODULE_3__/* .useInputTypingEventTracking */ .a)(innerRef, _platform_utils__WEBPACK_IMPORTED_MODULE_4__/* .AmplitudeContext */ .Lq, "input_change", {
        id: trackingIdentifier,
        label
    }, shouldTrackTerms);
    const inputClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().input), (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["button-input-icons"]), {
        [(_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["has-start-adornment"])]: variant === "live-search"
    }, inputClassName);
    const renderSearchButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return variant === "search-with-submit" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            disabled: disabled,
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["search-button"]),
            onClick: onSearchSubmit,
            type: searchButtonType,
            size: size,
            variant: "default",
            icon: _assets_icons_icons__WEBPACK_IMPORTED_MODULE_7__/* .ReactComponent */ .r,
            label: "Search",
            trackingIdentifier: "Search"
        });
    }, [
        disabled,
        size,
        variant,
        onSearchSubmit,
        searchButtonType
    ]);
    const renderClearButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            disabled: disabled,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["clear-button"]), (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[size], {
                [(_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["without-search-button"])]: variant !== "search-with-submit"
            }),
            onClick: onSearchClear,
            type: "button",
            size: size,
            variant: "ghost",
            icon: _assets_icons_icons__WEBPACK_IMPORTED_MODULE_8__/* .ReactComponent */ .r,
            label: "Clear",
            trackingIdentifier: "Clear"
        });
    }, [
        disabled,
        size,
        onSearchClear,
        variant
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["input-wrapper"]), {
            [(_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["disabled-input"])]: disabled
        }, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: id,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label), {
                    [(_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["visually-hidden"])]: hiddenLabel
                }),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["input-container"]), (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        disabled: disabled,
                        id: id,
                        className: inputClasses,
                        ref: innerRef,
                        ...rest
                    }),
                    variant === "live-search" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons_icons__WEBPACK_IMPORTED_MODULE_7__/* .ReactComponent */ .r, {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["start-adornment"])
                    }),
                    renderSearchButton,
                    renderClearButton
                ]
            })
        ]
    });
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SearchBar)));


/***/ }),

/***/ 8801:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-search-content":"category_main-search-content__dt_JT","guides-category-header":"category_guides-category-header__8dpVW","breadcrumbs":"category_breadcrumbs__TX8IW","back-mobile-button":"category_back-mobile-button__YEVjD","category-title-container":"category_category-title-container__uXU__","frame":"category_frame__xwyf1","page-category-title":"category_page-category-title__0eISn","theme--light":"category_theme--light__kba_v","theme--dark":"category_theme--dark__38JCi","search-wrapper":"category_search-wrapper__hPP4Z","articles-wrapper":"category_articles-wrapper___7NVi","articles-list":"category_articles-list__Kg08c","spinner-container":"category_spinner-container__BMx8g","fade-in-up":"category_fade-in-up__1IO4k","fade-in-opacity":"category_fade-in-opacity__tA0xt","fade-in-up-opacity":"category_fade-in-up-opacity__3wRqs","fade-out-opacity":"category_fade-out-opacity__RyAhe","fade-out-left":"category_fade-out-left__a3zy3"};

/***/ }),

/***/ 13090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumbs_breadcrumb__UbvPX","crumb":"breadcrumbs_crumb__Qd6tM","label":"breadcrumbs_label__3GNqD","disabled":"breadcrumbs_disabled__b91TY","theme--light":"breadcrumbs_theme--light__R5pOs","theme--dark":"breadcrumbs_theme--dark__yCgLt","slash":"breadcrumbs_slash__a8_C8","default":"breadcrumbs_default___II5X","fade-in-up":"breadcrumbs_fade-in-up__not7c","fade-in-opacity":"breadcrumbs_fade-in-opacity__bTGfh","fade-in-up-opacity":"breadcrumbs_fade-in-up-opacity__uLobT","fade-out-opacity":"breadcrumbs_fade-out-opacity__mjMYj","fade-out-left":"breadcrumbs_fade-out-left__RTvGI"};

/***/ }),

/***/ 86565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"search-bar_input-wrapper__HbJbQ","label":"search-bar_label__ig6YI","visually-hidden":"search-bar_visually-hidden__J0xED","theme--light":"search-bar_theme--light__fSTbc","theme--dark":"search-bar_theme--dark__51du9","input-container":"search-bar_input-container__Lf_yM","input":"search-bar_input__16D_w","clear-button":"search-bar_clear-button___Vd2B","start-adornment":"search-bar_start-adornment__CnPQA","search-button":"search-bar_search-button__S_XjS","small":"search-bar_small__JUQGZ","without-search-button":"search-bar_without-search-button__cXvEc","medium":"search-bar_medium__yI0wB","button-input-icons":"search-bar_button-input-icons__ohk3R","has-start-adornment":"search-bar_has-start-adornment__DphFI","disabled-input":"search-bar_disabled-input__GeBh6","fade-in-up":"search-bar_fade-in-up__DQw5T","fade-in-opacity":"search-bar_fade-in-opacity__uJdqe","fade-in-up-opacity":"search-bar_fade-in-up-opacity__EaAUK","fade-out-opacity":"search-bar_fade-out-opacity__wX6YV","fade-out-left":"search-bar_fade-out-left__6MsZU"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,577,955,196,559,735,881,774,888,179], function() { return __webpack_exec__(78127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);